import React from 'react';
import MicrosoftLogo from '../../assets/logos/microsoft.png';
import { EmailAnchor } from 'components/styled-components/common';
import { RootState } from 'StoreModel';
import { connect } from 'react-redux';
import { getBaseUrl } from '../../services/api/helper';

const mapStateToProps = (state: RootState) => ({
  literals: state.literals,
});

interface Props extends ReturnType<typeof mapStateToProps> {
  targetCommunityId?: number;
  targetCircleId?: number | null;
  targetTags?: string[] | null;
}

const MicrosoftLoginButton: React.FC<Props> = ({ literals, targetCommunityId, targetCircleId, targetTags }) => {
  const getRedirectUrl = () => {
    let url = `${getBaseUrl()}/api/Outlook/SignIn?redirectUrl=${window.location.href.split('?')[0]}`;
    if (targetCommunityId) {
      url += `&targetCommunityId=${targetCommunityId}`;
    }
    if (targetCircleId) {
      url += `&targetCircleId=${targetCircleId}`;
    }
    if (targetTags) {
      targetTags.forEach(tag => {
        url += `&targetTags=${tag}`;
      });
    }
    return url;
  };

  return (
    <EmailAnchor href={getRedirectUrl()}>
      <img src={MicrosoftLogo} width="30px" alt="microsoft" />
      <span>{literals.sign_in_with_microsoft_text}</span>
    </EmailAnchor>
  );
};

export default connect(mapStateToProps)(MicrosoftLoginButton);
